import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ReleasesSection } from 'libs/portal/src/models/ReleasesSection';

@Component({
  selector: 'app-releases',
  templateUrl: './releases.component.html',
  styleUrls: ['./releases.component.scss'],
})
export class ReleasesComponent implements OnInit {
  htmlSection: ReleasesSection[] = [];

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.http.get('assets/releases/releases.html', { responseType: 'text' }).subscribe((data) => {
      const pageSplit = data.split('SPLITPAGE');
      pageSplit.map((page) => {
        const splitPage = page.split('SPLITHEADER');
        this.htmlSection.push({
          header: this.sanitizer.bypassSecurityTrustHtml(splitPage[0]),
          body: this.sanitizer.bypassSecurityTrustHtml(splitPage[1]),
        });
      });
    });
  }
}
